import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError, EMPTY, throwError } from 'rxjs';

/**
 * App-level interceptor that catches 423 CLIENT_MOVE_IN_PROGRESS errors
 * when the user is inside a client context (/clients/:id/...) and
 * redirects to the client list with a clear message.
 *
 * Only handles 423 — does not interfere with 404/403 handling
 * (those are handled by canActivateClientGuard on navigation).
 *
 * The error is swallowed (EMPTY) so downstream error handlers
 * do not show a duplicate error dialog.
 */
export const clientMoveInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const dialog = inject(MatDialog);
  const snackbar = inject(MatSnackBar);

  return next(req).pipe(
    catchError((error) => {
      const url = router.url;
      const isClientContext = /\/clients\/[a-f0-9]{24}(\/|$)/.test(url);

      if (!isClientContext) return throwError(() => error);

      if (
        error.status === 423 &&
        error.error?.detail?.errorCode === 'CLIENT_MOVE_IN_PROGRESS'
      ) {
        dialog.closeAll();
        snackbar.open(
          'Deze cliënt wordt verplaatst en kan niet bewerkt worden.',
          'OK'
        );
        router.navigate(['/clients']);
        return EMPTY;
      }

      return throwError(() => error);
    })
  );
};
